const Negative = 0;
const Positive = 1;
const NotDecided = 2;
const OtherReservedValue = 3;

export default {
	Negative,
	Positive,
	NotDecided,
	OtherReservedValue,
};
